import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CoreState, coreFeatureName } from './core.reducer';

export const selectCoreState = createFeatureSelector<CoreState>(coreFeatureName);

export const selectIdentityState = createSelector(selectCoreState, (state: CoreState) => state.identity);
